
enum Domain {
	RATESHOPPER = 'RATESHOPPER', REVIEW_MANAGER = 'REVIEW_MANAGER', RMS = 'RMS', BI_TOOL = 'BI_TOOL'
}

export const DOMAIN_NAMES = new Map([
  [Domain.RATESHOPPER, 'Rateshopper'],
  [Domain.REVIEW_MANAGER, 'Review Manager'],
  [Domain.RMS, 'RMS'],
  [Domain.BI_TOOL, 'BI'],
])

export default Domain;
